import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { mergeProps, useFocusRing, useTableColumnHeader } from 'react-aria';

import styles from './TableColumnHeader.module.scss';

const TableColumnHeader = ({ column, state, className, ...otherProps }) => {
    const ref = useRef();
    const { columnHeaderProps } = useTableColumnHeader(
        { node: column },
        state,
        ref
    );
    const { isFocusVisible, focusProps } = useFocusRing();

    const {
        colspan,
        rendered
    } = column;

    return (
        <th
            {...mergeProps(columnHeaderProps, focusProps)}
            colSpan={colspan}
            className={['govuk-table__header',
                styles.cell,
                isFocusVisible ? styles.focus : null,
                className
            ].join(' ')}
            ref={ref}
            data-testid={otherProps['data-testid'] ? otherProps['data-testid'] + '.th' : null}
        >
            {rendered}
        </th>
    );
};

TableColumnHeader.propTypes = {
    column: PropTypes.any,
    state: PropTypes.object,
    className: PropTypes.string,
    'data-testid': PropTypes.string
};

export default TableColumnHeader;
